import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { MdInputModule, MdDatepickerModule, MdNativeDateModule, MdTabsModule, DateAdapter, MD_DATE_FORMATS } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { appRouting } from './app.routing';
import { AppComponent } from './app.component';
import { LoginComponent } from './account/login/login.component';
import { AuthguardService } from './common/services/authguard.service';
import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './home/header/header.component';
import { FooterComponent } from './home/footer/footer.component';
import { SidenavComponent } from './home/sidenav/sidenav.component';
import { LoaderComponent } from './common/loader/loader.component';
import { ResetPasswordComponent } from './account/reset-password/reset-password.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { PayrollLogComponent } from './payroll-log/payroll-log.component';
import { RestCallerService } from './common/services/rest-caller.service';
import { ClientPayrollManagementComponent } from './client-payroll-management/client-payroll-management.component';
import { ImpExportService } from 'app/common/services/imp-export.service';
import { CustomDateAdapter } from './common/services/date-adapter.service'
import { ClientManagementComponent } from './client-management/client-management.component';
import { LogBookComponent } from './log-book/log-book.component';
import { ReportsComponent } from './reports/reports.component';
import { CalculationEngineComponent } from './calculation-engine/calculation-engine.component'
import { APP_DATE_FORMATS } from './common/constants/constants'

import { DecimalPipe } from '@angular/common';
import { OrderByPipe } from './common/pipes/orderby.pipe';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    SidenavComponent,
    LoaderComponent,
    ResetPasswordComponent,
    UserManagementComponent,
    PayrollLogComponent,
    ClientPayrollManagementComponent,
    ClientManagementComponent,
    LogBookComponent,
    ReportsComponent,
    CalculationEngineComponent,
    OrderByPipe
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    HttpModule,
    appRouting,
    MdInputModule,
    MdDatepickerModule,
    MdNativeDateModule,
    MdTabsModule,
    BrowserAnimationsModule 
  ],
  providers: [AuthguardService, RestCallerService, ImpExportService, DecimalPipe, {provide: DateAdapter, useClass: CustomDateAdapter}, {provide: MD_DATE_FORMATS, useValue: APP_DATE_FORMATS}],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts